<script setup>

</script>

<template>
    <Panel>
        <template #header>
            <h4>Privacy &amp; Verification</h4>
        </template>
    </Panel>
</template>

<style scoped>

</style>